import React from 'react';

const MenuArrow = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 12" aria-hidden="true" focusable="false" fill="none" {...props}>
        <path stroke="currentColor" stroke-width="1.5" d="M18.547 1.485 9.47 10.577 1.001 2.09"></path>
    </svg>
);

export default MenuArrow;